import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=3a4b4869&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=3a4b4869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b4869",
  null
  
)

export default component.exports